import { MEDIA_MODEL_CLASS_NAME, MEDIA_MODEL_KEY } from '../model'
import { MEDIA_ACTION, MEDIA_ENDPOINT, MEDIA_PATH } from '../redux'
import { getByIdMediaSelector } from '../selectors'
import getCurrentIdProfileSelect from '../../profile/redux/selectors/get-current-id'
import createReduxAction from '../../redux/actions/create'
import saveReduxAction from '../../redux/actions/save'
import { setIdReduxAction } from '../../redux/actions/set-id'
import updateReduxAction from '../../redux/actions/update'
import REDUX_OPTION from '../../redux/constants/option'
import { getActionStrReduxUtil } from '../../redux/utils/get-action-str'
import { getIdReduxUtil } from '../../redux/utils/get-id'
import getInstanceReduxUtil from '../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../redux/utils/get-path'
import { getUrlWithQueryStringUtil, logUtil } from 'packages/src'

export function updateCurrentMediaAction (id) {
  return setIdReduxAction({
    type: getActionStrReduxUtil(MEDIA_ACTION.UPDATE_CURRENT, id),
    payload: {
      path: MEDIA_PATH.CURRENT,
      id
    }
  })
}

export function createMediaAction ({
  query,
  formData,
  uri,
  headers
} = {}) {
  return async (dispatch, getState) => {
    const endpoint = getUrlWithQueryStringUtil(MEDIA_ENDPOINT.ROOT, query)
    logUtil('createMediaAction')
      .debug(`endpoint ${endpoint}, query: `, query)
    const options = {
      [REDUX_OPTION.IS_IMMEDIATE]: true,
      [REDUX_OPTION.SHOW_ERROR]: true
    }

    const profileId = getCurrentIdProfileSelect(getState())
    let media = dispatch(createReduxAction({
      type: MEDIA_ACTION.CREATE,
      payload: {
        domainListPath: MEDIA_PATH.ALL,
        data: {
          className: MEDIA_MODEL_CLASS_NAME,
          changed: {
            [MEDIA_MODEL_KEY.PROFILE_ID]: profileId,
            [MEDIA_MODEL_KEY.URL]: '',
            [MEDIA_MODEL_KEY.LOCAL_URI]: uri
          }
        }
      }
    }))

    dispatch(updateCurrentMediaAction(getIdReduxUtil(media)))

    const res = await dispatch(saveReduxAction({
      type: MEDIA_ACTION.CREATE,
      payload: {
        options,
        method: 'POST',
        fetchOptions: {
          headers: headers || {
            'Content-Type': 'multipart/form-data'
          },
          body: formData
        },
        endpoint,
        domainListPath: MEDIA_PATH.ALL,
        path: getPathReduxUtil(media)
      }
    }))

    media = getByIdMediaSelector(getIdReduxUtil(res?.data?.media))(getState())

    dispatch(updateReduxAction({
      type: 'MEDIA_UPDATE_LOCAL_URI',
      payload: {
        path: getPathReduxUtil(media),
        key: MEDIA_MODEL_KEY.LOCAL_URI,
        value: uri
      }
    }))

    media = getInstanceReduxUtil(getState(), media)

    return media
  }
}
